import PndRestApi from '../../utils/pnd/PndRestApi';

export const GET_ORDER_PREFERENCES = 'GET_ORDER_PREFERENCES';
export const GET_ORDER_PREFERENCES_SUCCESS = 'GET_ORDER_PREFERENCES_SUCCESS';
export const GET_ORDER_PREFERENCES_FAILURE = 'GET_ORDER_PREFERENCES_FAILURE';

export function getOrderPreferences() {
  return async (dispatch) => {
    dispatch({ type: GET_ORDER_PREFERENCES });
    try {
      const response = await PndRestApi.GetOrderPreferencesByCustomerId();
      if (response && response?.status === 200 && response?.data?.status === 200) {
        dispatch({
          type: GET_ORDER_PREFERENCES_SUCCESS,
          payload: response.data?.data,
        });
      } else {
        dispatch({
          type: GET_ORDER_PREFERENCES_FAILURE,
          payload: "No data received",
        });
      }

    } catch (error) {
      dispatch({
        type: GET_ORDER_PREFERENCES_FAILURE,
        payload: error,
      });
    }
  };
}
